import '../app/app.component.css';
import { useState } from 'react';
import katie from './img/cast/katie.jpeg'
import aby from './img/cast/aby.jpeg';
import briana from './img/cast/briana.jpeg';
import carly from './img/cast/carly.jpeg';
import dianna from './img/cast/dianna.jpg';
import ella from './img/cast/ella.jpeg';
import graham from './img/cast/graham.jpeg';
import jack from './img/cast/jack.jpeg';
import jennifer from './img/cast/jennifer.jpg';
import julia from './img/cast/julia.jpeg';
import lili from './img/cast/lili.jpeg';
import marissa from './img/cast/marissa.jpeg';
import mich from './img/cast/michealene.jpeg';
import olivia from './img/cast/olivia.jpeg';
import saira from './img/cast/saira.jpeg';
import scottlynn from './img/cast/scottlynn.jpeg';
import shannon from './img/cast/shannon.jpeg';
import stephanie from './img/cast/stephanie.jpeg';
import whitney from './img/cast/whitney.jpeg';



export const CastPage = () => {
  const [activeItem, setActiveItem] = useState<number | null>(null);

  const handleItemClick = (index: number) => {
    setActiveItem(index === activeItem ? null : index);
  };

  return (
    <main>
      <h1 style={{ textAlign: 'center', marginTop: '50px', display: 'flex', justifyContent: 'center', color: '#496a86', fontFamily: 'cursive', fontSize: '40px' }}>Founders & Cast</h1>
      <div className='character-container'>
        {/* Character items */}
        <div className="character-item" onClick={() => handleItemClick(0)}>
          <img src={katie} alt="Tinkerbell" className="character-image" />
          <div className={`character-text ${activeItem === 0 ? 'active' : ''}`}>Kathryn Zutter</div>
          <div className={`character-desc ${activeItem === 0 ? 'active' : ''}`}>Co-Founder<br/>Cast Director/Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(1)}>
          <img src={briana} alt="Briana Niven" className="character-image" />
          <div className={`character-text ${activeItem === 1 ? 'active' : ''}`}>Briana Niven</div>
          <div className={`character-desc ${activeItem === 1 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(2)}>
          <img src={jennifer} alt="Jennifer Lenius" className="character-image" />
          <div className={`character-text ${activeItem === 2 ? 'active' : ''}`}>Jennifer Lenius</div>
          <div className={`character-desc ${activeItem === 2 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(3)}>
          <img src={graham} alt="Graham Todd" className="character-image" />
          <div className={`character-text ${activeItem === 3 ? 'active' : ''}`}>Graham Todd</div>
          <div className={`character-desc ${activeItem === 3 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(4)}>
          <img src={saira} alt="Saira Shariff" className="character-image" />
          <div className={`character-text ${activeItem === 4 ? 'active' : ''}`}>Saira Shariff</div>
          <div className={`character-desc ${activeItem === 4 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(5)}>
          <img src={marissa} alt="Marissa Longo" className="character-image" />
          <div className={`character-text ${activeItem === 5 ? 'active' : ''}`}>Marissa Longo</div>
          <div className={`character-desc ${activeItem === 5 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(6)}>
          <img src={dianna} alt="Dianna Todd" className="character-image" />
          <div className={`character-text ${activeItem === 6 ? 'active' : ''}`}>Dianna Todd</div>
          <div className={`character-desc ${activeItem === 6 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(7)}>
          <img src={julia} alt="Julia Argon" className="character-image" />
          <div className={`character-text ${activeItem === 7 ? 'active' : ''}`}>Julia Argon</div>
          <div className={`character-desc ${activeItem === 7 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(8)}>
          <img src={jack} alt="Jack Baust" className="character-image" />
          <div className={`character-text ${activeItem === 8 ? 'active' : ''}`}>Jack Baust</div>
          <div className={`character-desc ${activeItem === 8 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(9)}>
          <img src={whitney} alt="Whitney Wolf" className="character-image" />
          <div className={`character-text ${activeItem === 9 ? 'active' : ''}`}>Whitney Wolf</div>
          <div className={`character-desc ${activeItem === 9 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(10)}>
          <img src={olivia} alt="Olivia Zak" className="character-image" />
          <div className={`character-text ${activeItem === 10 ? 'active' : ''}`}>Olivia Zak</div>
          <div className={`character-desc ${activeItem === 10 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(11)}>
          <img src={carly} alt="Carly Nadeua" className="character-image" />
          <div className={`character-text ${activeItem === 11 ? 'active' : ''}`}>Carly Nadeua</div>
          <div className={`character-desc ${activeItem === 11 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(12)}>
          <img src={lili} alt="Lili Galluzzo" className="character-image" />
          <div className={`character-text ${activeItem === 12 ? 'active' : ''}`}>Lili Galluzzo</div>
          <div className={`character-desc ${activeItem === 12 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(13)}>
          <img src={aby} alt="Aby Jayne" className="character-image" />
          <div className={`character-text ${activeItem === 13 ? 'active' : ''}`}>Aby Jayne</div>
          <div className={`character-desc ${activeItem === 13 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(14)}>
          <img src={ella} alt="Ella Leon" className="character-image" />
          <div className={`character-text ${activeItem === 14 ? 'active' : ''}`}>Ella Leon</div>
          <div className={`character-desc ${activeItem === 14 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(15)}>
          <img src={scottlynn} alt="Scottlynn Stroming" className="character-image" />
          <div className={`character-text ${activeItem === 15 ? 'active' : ''}`}>Scottlynn Stroming</div>
          <div className={`character-desc ${activeItem === 15 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(16)}>
          <img src={stephanie} alt="Stephanie Fongheiser" className="character-image" />
          <div className={`character-text ${activeItem === 16 ? 'active' : ''}`}>Stephanie Fongheiser</div>
          <div className={`character-desc ${activeItem === 16 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(17)}>
          <img src={shannon} alt="Shannon Burke" className="character-image" />
          <div className={`character-text ${activeItem === 17 ? 'active' : ''}`}>Shannon Burke</div>
          <div className={`character-desc ${activeItem === 17 ? 'active' : ''}`}>Performer</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(18)}>
          <img src={mich} alt="Michaelene Marchetta" className="character-image" />
          <div className={`character-text ${activeItem === 18 ? 'active' : ''}`}>Michaelene Marchetta</div>
          <div className={`character-desc ${activeItem === 18 ? 'active' : ''}`}>Performer</div> 
        </div>
      </div>
    </main>
  );
}

export default CastPage;
